import React from "react";
import { Outlet } from "react-router-dom";
import SupportAgentHeader from "./components/header/SupportAgentHeader";
import SupportAgentSidebar from "./components/sidebar/SupportAgentSidebar";
import Footer from "../../components/footer/Footer";
import { ClientStatusProvider } from "../../views/context/clientContext";
import { HeaderSlotProvider } from "../../contexts/HeaderSlotContext";
// import brandMark from "../../assets/img/serviceloom-mark-blue.svg";

const CANVAS_BG =
  "radial-gradient(ellipse 711px 1111px at 100% 25%, rgba(76, 53, 215, 0.4) 0%, rgba(233, 240, 254, 0) 70%), #E9F0FE";

export default function SupportAgentLayout() {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  return (
    <ClientStatusProvider>
      <HeaderSlotProvider>
        <div
          className="flex h-screen w-full overflow-hidden"
          style={{
            background: CANVAS_BG,
            backdropFilter: "blur(90px)",
            WebkitBackdropFilter: "blur(90px)",
          }}
        >

          {/* Sidebar */}
          <SupportAgentSidebar
            open={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
          />

          {/* Main Section */}
          <div className="flex flex-col flex-1 h-[100%] overflow-hidden relative">

            {/* Brand mark — top-left accent */}
            {/* <img
              src={brandMark}
              alt="ServiceLoom"
              className="absolute top-4 left-4 w-6 h-6 pointer-events-none z-20 hidden md:block"
            /> */}

            {/* Header */}
            <SupportAgentHeader
              onOpenSidenav={() => setSidebarOpen(true)}
            />

            {/* Page Content */}
            <main className="flex-1 min-h-0 overflow-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
              <div className="w-full px-5 pb-5 pt-3 min-h-full flex flex-col">
                <Outlet />
              </div>
            </main>

          </div>
        </div>
      </HeaderSlotProvider>
    </ClientStatusProvider>
  );
}
